import localization from "../../../../assets/localization";

/**
 * AI Act Art. 50(1) disclosure — the guest must be told they're talking to a
 * machine, in a clear and distinguishable way, no later than the first
 * interaction. It sits directly above the input box because the Commission's
 * guidelines recommend placing the disclosure next to the input/output field,
 * and it stays until the guest sends their first message of the session.
 *
 * Deliberately NOT hotel-configurable: the obligation is on us as the provider
 * of the AI system, so no accommodation gets to blank it out from the
 * backoffice the way it can with the welcome message.
 */
export default function AiDisclosure({ language }: { language: string }) {
  return (
    <div className="widget-ai-disclosure" role="note">
      <i className="fa-solid fa-circle-info" aria-hidden="true"></i>
      <span>{localization.get(language).ai_disclosure}</span>
    </div>
  );
}
